import { useMemo } from 'react'

import { IContactsWithMultiplePartners } from 'onboarding/features/models/contactsWithMultiplePartners'

export function useContactWithMultiplePartners(
  email: string,
  contacts: IContactsWithMultiplePartners[] | undefined
) {
  return useMemo(() => {
    if (!email || !contacts?.length) {
      return {
        contactWithMultiplePartners: undefined,
        isMultiplePartners: false,
      }
    }

    const normalizedEmail = email.toLowerCase()

    const found = contacts.find((contact) => contact.email.toLowerCase() === normalizedEmail)

    return {
      contactWithMultiplePartners: found,
      isMultiplePartners: Boolean(found),
    }
  }, [email, contacts])
}
